const isEnabled = () => localStorage.getItem('bizai20DebugMode') === 'true';

const debugLogger = {
  info: (...args) => isEnabled() && console.info(...args), // eslint-disable-line no-console
  debug: (...args) => isEnabled() && console.debug(...args), // eslint-disable-line no-console
  groupCollapsed: (...args) => isEnabled() && console.groupCollapsed(...args), // eslint-disable-line no-console
  groupEnd: () => isEnabled() && console.groupEnd(), // eslint-disable-line no-console
};

export default debugLogger;
